import { Eye, X } from 'lucide-react';
import { usePermissions } from '../contexts/PermissionsContext';

const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  demo_admin: 'Demo Admin',
  manager: 'Manager',
  operator: 'Operator',
  location_manager: 'Location Manager',
  location_user: 'Location User',
  employee: 'Employee',
};

const RolePreviewBanner = () => {
  const { isPreviewActive, previewRole, stopPreview } = usePermissions();

  if (!isPreviewActive) return null;

  return (
    <div
      className="sticky top-0 z-[60] flex items-center justify-center gap-3 px-4 py-2 bg-violet-600 text-white text-sm font-medium shadow-md"
      data-testid="role-preview-banner"
    >
      <Eye className="w-4 h-4 shrink-0" />
      <span>
        Previewing as <strong>{ROLE_LABELS[previewRole] || previewRole}</strong> — sidebar &amp; pages reflect this role's permissions
      </span>
      <button
        onClick={stopPreview}
        className="ml-2 inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-white/20 hover:bg-white/30 transition-colors text-xs font-semibold"
        data-testid="exit-preview-btn"
      >
        <X className="w-3.5 h-3.5" />
        Exit Preview
      </button>
    </div>
  );
};

export default RolePreviewBanner;
